// src/pages/HomeContent.js
import React from 'react';
// Importa aquí todos los componentes que estaban en tu Home (HeroSection, AboutSection, etc.)
import HeroSection from '../components/HeroSection'; 
import AboutSection from '../components/AboutSection';
import ServiceSection from '../components/ServiceSection'; 
import CeoSection from '../components/CeoSection'; 
import BookPromoSection from '../components/BookPromoSection';
import YoutubeSection from '../components/YoutubeSection';
import FileUploadSection from '../components/FileUploadSection'; 
import LegalDisclaimer from '../components/LegalDisclaimer';

const HomeContent = () => {
    // Nota: Eliminamos setActivePage ya que las rutas las maneja el router
    return (
        <>
            <HeroSection /> 
            <AboutSection />
            <CeoSection /> 
            <ServiceSection /> 
            <BookPromoSection /> 
            <FileUploadSection /> 
            <YoutubeSection />
            <LegalDisclaimer />
        </>
    );
};
export default HomeContent;